// Single source of truth for the "Featured resource" document shown on the
// landing hub and in the chat header.
//
// The document is served ONLY through the Keycloak-gated backend endpoint
// GET /documents/{id} (streamed from a private blob). No storage/SAS/blob
// URL is ever exposed to the client — `id` must match a key in the backend
// DOCUMENTS_REGISTRY. Add more docs by registering them on both sides.

export interface FeaturedDoc {
  id: string; // must match backend DOCUMENTS_REGISTRY key
  title: string;
  subtitle: string;
}

export const FEATURED_DOC: FeaturedDoc = {
  id: 'tmpvl-accounting-manual-2026',
  title: 'TMPVL Accounting Manual 2026',
  subtitle: 'Accounting policies & procedures — open to view and search the full manual.',
};
